"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNotification = exports.NotificationProvider = exports.NotificationContext = void 0;
const react_1 = __importStar(require("react"));
const DEFAULT_TTL = 3000; // in ms
exports.NotificationContext = (0, react_1.createContext)({});
const NotificationProvider = ({ children, }) => {
    const [notifications, setNotifications] = (0, react_1.useState)([]);
    const closeNotification = (0, react_1.useCallback)((id) => {
        setNotifications(notifications => notifications.filter(notification => notification.id !== id));
    }, []);
    /**
     * @param newNotification Notification
     * @param autoClose boolean default value is true
     */
    const showNotification = (0, react_1.useCallback)((newNotification, autoClose = true) => {
        const id = Symbol(newNotification.message);
        setNotifications(notifications => [
            ...notifications,
            { ...newNotification, id },
        ]);
        if (autoClose) {
            setTimeout(() => {
                closeNotification(id);
            }, DEFAULT_TTL);
        }
    }, [closeNotification]);
    const closeAllNotifications = (0, react_1.useCallback)(() => {
        setNotifications([]);
    }, []);
    const value = (0, react_1.useMemo)(() => ({
        showNotification,
        notifications,
        closeNotification,
        closeAllNotifications,
    }), [showNotification, notifications, closeNotification, closeAllNotifications]);
    return (react_1.default.createElement(exports.NotificationContext.Provider, { value: value }, children));
};
exports.NotificationProvider = NotificationProvider;
function useNotification() {
    return (0, react_1.useContext)(exports.NotificationContext);
}
exports.useNotification = useNotification;
//# sourceMappingURL=Notification.js.map